export const METADATA_SETTINGS_GUIDE_LANGUAGES = Object.freeze([
  'en', 'tr', 'es', 'fr', 'de', 'it', 'id', 'th', 'pt'
]);

const METADATA_SETTINGS_GUIDE_LINK_LABELS = {
  en: 'Open the Metadata Settings Guide in a new tab',
  tr: 'Metadata Ayarları Rehberi’ni yeni sekmede aç',
  es: 'Abrir la Guía de Configuración de Metadatos en una pestaña nueva',
  fr: 'Ouvrir le Guide des paramètres de métadonnées dans un nouvel onglet',
  de: 'Leitfaden zu den Metadaten-Einstellungen in einem neuen Tab öffnen',
  it: 'Apri la Guida alle Impostazioni dei Metadati in una nuova scheda',
  id: 'Buka Panduan Pengaturan Metadata di tab baru',
  th: 'เปิดคู่มือการตั้งค่า Metadata ในแท็บใหม่',
  bn: 'Metadata Settings গাইডটি নতুন ট্যাবে খুলুন',
  hi: 'Metadata Settings गाइड नए टैब में खोलें',
  pt: 'Abrir o Guia de Configurações de Metadados em uma nova aba'
};

export const resolveMetadataSettingsGuideLanguage = (value = 'en') => {
  const normalized = String(value || 'en').trim().toLowerCase().split(/[-_]/)[0] || 'en';
  return METADATA_SETTINGS_GUIDE_LANGUAGES.includes(normalized) ? normalized : 'en';
};

export const getMetadataSettingsGuideLinkLabel = (value = 'en') => (
  METADATA_SETTINGS_GUIDE_LINK_LABELS[String(value || 'en').trim().toLowerCase().split(/[-_]/)[0]]
  || METADATA_SETTINGS_GUIDE_LINK_LABELS.en
);
